module.exports = __webpack_public_path__ + "static/media/trip_address.fb2d4453.svg";